import { INPUT_TYPE } from "deskera-ui-library";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { COUNTRY } from "../../../constants/CountryConstant";
import moment from "moment";
import {
  FIN_REGEX,
    IFSC_PATTERN,
  NRIC_REGEX,
    PAN_REGEX_PATTERN,
    PF_ACCOUNT_PATTERN_IMPORT,
    ROUTING_NUMBER_REGEX,
    SSN_REGEX,
    UAN_NUMBER_REGEX,
    UPI_PATTERN,
    ZIPCODE_REGEX_IMPORT
} from "../../../constants/RegexConstants";
import Utility from "../../../utility/Utility";
import { getCompensationInPerMonth, getCountryPhoneCode, isUSCompliance } from "../../../managers/common/CommonUtil";
import { TABLES } from "../../../managers/TableManger";
import { CONSTANTS } from "../../../constants/Constant";

export function convertToCSV(objArray) {
    let json = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let fields = Object.keys(json[0]);

    function notHeader(header) {
        let exclude = ["error", "validationMessages"];
        return !exclude.includes(header);
    }

    fields = fields.filter(notHeader);

    let replacer = function (key, value) {
        return value === null ? "" : value;
    };

    let csv = json.map(function (row) {
        return fields
            .map(function (fieldName) {
                return JSON.stringify(row[fieldName], replacer);
            })
            .join(",");
    });

    csv.unshift(fields.join(","));
    csv = csv.join("\r\n");
    return csv;
}

function enrichOptions(options) {
    if (Array.isArray(options)) {
        options = options.map((o) => {
            return {
                id: String(o).toLowerCase(),
                name: o
            }
        });
    } else {
        options = [];
    }

    return options;
}

export const FIELD = {
    EMAIL: "email",
    DATE_OF_BIRTH: "dateOfBirth",
    GENDER: "gender",
    DATE_OF_JOINING: "dateOfJoining",
    CONFIRMATION_DATE: "confirmationDate",
    PERIOD: "period",
    PAYMENT_METHOD: "paymentMethod",
    ACCOUNT_NUMBER: "accountNumber",
    ACCOUNT_TYPE: "accountType",
    SWIFT_ROUTING: "swiftCodeOrRouting",
    STATE: "state",
    ZIPCODE: "zipcode",
    PAN: "permanentAccountNumber",
    UAN: "uanNumber",
    PF_ACCOUNT_NUMBER: "pfAccountNumber",
    EMPLOYEE_PF: "employeeProvidentFund",
    PROFESSIONAL_TAX: "professionalTax",
    EXEMPT_TAX: "exemptFromTaxCalculation",
    CTC: "ctc",
    BASIC_SALARY: "basicSalary",
    COUNTY: "county",
    SSN: "socialSecurityNumber",
    EIC_CODE: "eicCode",
    MARITAL_STATUS: "maritalFilingStatus",
    DEPENDENT_CLAIM: "dependentClaims",
    OTHER_INCOME: "otherIncome",
    DEDUCTIONS: "deductions",
    EXTRA_WITHHOLDING: "extraWithholdings",
    IS_2C_MARKED: "is2CMarkedInW4",
    STATE_INDICATOR: "selectedStateIndicator",
    FED_TERRITORY: "fedWithTerritory",
    RETURN_ALL_STATES: "returnAllStates",
    RESIDENT_COUNTRY: "residentCountry",
    STATUTORY_INDICATOR: "statutoryIndicator",
    FOREIGN_INCOME: "foreignIncome",
    TAX_EXEMPT: "taxExempt",
    PHONE: "phone",
    IFSC: "ifsc",
    UPI: "upi",
    PUNCH_TYPE:"punchType",
    IS_FIRST: "isFirst",
    IS_LAST: "isLast",
    PUNCH_DATE: "punchDate",
    PUNCH_TIME: "punchTime",
    BANK: "bank",
    LOCATION: "location",
    EIS_CONTRIBUTION: "eisContribution",
    SOCSO_EMPLOYER_ONLY: "socsoEmployerContributionOnly",
    EPF_APPLICABLE: "epfApplicable",
    EPF_MEMBER: "epfMember",
    EMPLOYER_BEARING_PCB :"employerBearingPcb",
    HAVING_CHILDREN: "havingChildren",
    SPOUSE_WORKING: "spouseWorking",
    TAX_EXEMPT: "taxExemption",
    BIK_CONTRIBUTION: "bikContribution",
    NUMBER_QUALIFYING_CHILDREN: "qualifyingChildrenNumber",
    NUMBER_CHILDREN_ABOVE_18_OUTSIDE_MY: "numberOfChildrenAbove18ReceivingDegreeOutsideMalaysia",
    NUMBER_CHILDREN_ABOVE_18_IN_MY: "numberOfChildrenAbove18ReceivingDiplomaInMalaysia",
    NUMBER_CHILDRE_UNDER_18: "numberOfChildrenUnder18",
    NUMBER_DISABLED_CHILDREN: "numberOfDisabledChildren",
    NUMBER_DISABLED_CHILDREN_STUDYING: "numberOfDisabledChildrenStudying",
    EMPLOYEE_QUALIFICATION: "employeeQualification",
    START_OF_PERMANENT_RESIDENT: "startOfPermanentResident",
    MTD_EXEMPTION: "mtdExemption",
    UID: "uid",
    START_DATE: "startDate",
    DEFAULT_HRS: "hourlyWageDefaultHrs",
    IMMIGRATION_STATUS: "immigrationStatus",
    NATIONALITY: "nationality",
    COUNTRY_OF_ORIGIN: "countryOfOrigin",
    RACE: "race",
    RELIGION: "religion",
    SDL_APPLICABLE: "sdlApplicable",
    FWL_APPLICABLE: "fwlApplicable",
    NRIC_FIN: "nricOrFin",
    REPORTING_MANAGER_NAME: "reportingManagerName"
}

export function enrichMapping(systemHeader, country, customFields, customFieldModule) {
    const config = {
        fieldId: systemHeader.id,
        id: systemHeader.fieldName,
        key: systemHeader.fieldName,
        name: systemHeader.displayName,
        type: INPUT_TYPE.TEXT,
        pattern: null,
        options: null,
        width: 250
    }

    if (systemHeader.customFieldConfig) {
        switch (systemHeader.dataType) {
            case "date":
                config.type = INPUT_TYPE.DATE;
                break;
            case "number":
                config.type = INPUT_TYPE.NUMBER;
                break;
            case "dropdown":
                config.type = INPUT_TYPE.SELECT;
                config.options = enrichOptions(systemHeader.possibleValues);
                config.allowAddOption = false;
                break;
            default:
                config.type = INPUT_TYPE.TEXT;
                break;
        }
    } else {
        switch (systemHeader.fieldName) {
            case FIELD.EMAIL:
                config.type = INPUT_TYPE.EMAIL;
                break;
    
            case FIELD.DATE_OF_BIRTH:
            case FIELD.DATE_OF_JOINING:
            case FIELD.CONFIRMATION_DATE:
            case FIELD.PUNCH_DATE:
                config.type = INPUT_TYPE.DATE;
                break;
    
            case FIELD.GENDER:
            case FIELD.PERIOD:
            case FIELD.PAYMENT_METHOD:
            case FIELD.ACCOUNT_TYPE:
            case FIELD.EMPLOYEE_PF:
            case FIELD.PROFESSIONAL_TAX:
            case FIELD.EXEMPT_TAX:
            case FIELD.EIC_CODE:
            case FIELD.MARITAL_STATUS:
            case FIELD.STATE_INDICATOR:
            case FIELD.FED_TERRITORY:
            case FIELD.RETURN_ALL_STATES:
            case FIELD.RESIDENT_COUNTRY:
            case FIELD.STATUTORY_INDICATOR:
            case FIELD.FOREIGN_INCOME:
            case FIELD.TAX_EXEMPT:
            case FIELD.IS_2C_MARKED:
            case FIELD.PUNCH_TYPE:
            case FIELD.IS_FIRST:
            case FIELD.IS_LAST:
            case FIELD.BANK:
            case FIELD.LOCATION:
            case FIELD.EIS_CONTRIBUTION:
            case FIELD.SOCSO_EMPLOYER_ONLY:
            case FIELD.EPF_APPLICABLE:
            case FIELD.EPF_MEMBER:
            case FIELD.EMPLOYER_BEARING_PCB:
            case FIELD.HAVING_CHILDREN:
            case FIELD.SPOUSE_WORKING:
            case FIELD.TAX_EXEMPT:
            case FIELD.BIK_CONTRIBUTION:
            case FIELD.MTD_EXEMPTION:
                config.type = INPUT_TYPE.SELECT;
                config.options = enrichOptions(systemHeader.possibleValues);
                config.allowAddOption = false;
                break;
            case FIELD.IMMIGRATION_STATUS:
            case FIELD.NATIONALITY:
            case FIELD.COUNTRY_OF_ORIGIN:
            case FIELD.RACE:
            case FIELD.RELIGION:
            case FIELD.FWL_APPLICABLE:
            case FIELD.SDL_APPLICABLE:
            case FIELD.EMPLOYEE_QUALIFICATION:    
                config.type = "dropdown";
                config.options = enrichOptions(systemHeader.possibleValues);
                config.dropdownConfig = {
                    allowSearch: true,
                    searchableKey: "label",
                    data: systemHeader.possibleValues,
                    renderer: (i, item) => item,
                    onSelect: (i, value) => {}
                }
                break;
            case FIELD.CTC:
            case FIELD.BASIC_SALARY:
            case FIELD.DEPENDENT_CLAIM:
            case FIELD.OTHER_INCOME:
            case FIELD.DEDUCTIONS:
            case FIELD.EXTRA_WITHHOLDING:
            case FIELD.NUMBER_QUALIFYING_CHILDREN:
            case FIELD.NUMBER_CHILDREN_ABOVE_18_OUTSIDE_MY:
            case FIELD.NUMBER_CHILDREN_ABOVE_18_IN_MY:
            case FIELD.NUMBER_CHILDRE_UNDER_18:
            case FIELD.NUMBER_DISABLED_CHILDREN:
            case FIELD.NUMBER_DISABLED_CHILDREN_STUDYING:
                config.type = INPUT_TYPE.NUMBER;
                break;
    
            case FIELD.STATE:
                switch (country) {
                    case COUNTRY.IN:
                    case COUNTRY.US:
                        config.type = INPUT_TYPE.SELECT;
                        config.options = enrichOptions(systemHeader.possibleValues);
                        config.allowAddOption = false;
                        break;
                    default:
                        config.type = INPUT_TYPE.TEXT;
                        break;
                }
                break;
    
            case FIELD.SWIFT_ROUTING:
                config.type = INPUT_TYPE.TEXT;
                switch (country) {
                    case COUNTRY.US:
                        config.pattern = ROUTING_NUMBER_REGEX[COUNTRY.US];
                        break;
                }
                break;
    
            case FIELD.ZIPCODE:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = ZIPCODE_REGEX_IMPORT[country];
                break;
    
            case FIELD.PAN:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = PAN_REGEX_PATTERN;
                break;
    
            case FIELD.UAN:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = UAN_NUMBER_REGEX;
                break;
    
            case FIELD.PF_ACCOUNT_NUMBER:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = PF_ACCOUNT_PATTERN_IMPORT;
                break;
    
            case FIELD.SSN:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = SSN_REGEX;
                break;
    
            case FIELD.IFSC:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = IFSC_PATTERN;
                break;
    
            case FIELD.UPI:
                config.type = INPUT_TYPE.TEXT;
                config.pattern = UPI_PATTERN;
                break;
    
            case FIELD.UID:
                if (country === COUNTRY.IN) {
                    config.type = INPUT_TYPE.TEXT;
                    config.pattern = PAN_REGEX_PATTERN;
                }
                break;
            case FIELD.COUNTY:
                if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                    config.type = INPUT_TYPE.TEXT;
                } else {
                    config.type = INPUT_TYPE.SELECT;
                    config.options = enrichOptions(systemHeader.possibleValues);
                    config.allowAddOption = false;
                }
                break;
            case FIELD.REPORTING_MANAGER_NAME:
                if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
                    config.required = true;
                }
                break;
            default:
                break;
        }
    
        if (customFieldModule && customFields?.length > 0) {
            const customField = customFields.find((cf) => cf.id === systemHeader.customFieldId);
    
            if (customField?.mappedWith.includes(customFieldModule)) {
                switch (customField.type) {
                    case "text":
                        config.type = INPUT_TYPE.TEXT;
                        config.maxLength = !isNaN(parseInt(customField.maxLength)) ? parseInt(customField.maxLength) : -1;
                        break;
                    case "number":
                        config.type = INPUT_TYPE.NUMBER;
                        config.decimalPrecision = !isNaN(parseInt(customField.decimalPrecision)) ? parseInt(customField.decimalPrecision) : -1;
                        break;
                    case "multiselect":
                        config.type = INPUT_TYPE.SELECT;
                        config.options = enrichOptions(systemHeader.possibleValues);
                        config.allowAddOption = false;
                        break;
                    case "date":
                        config.type = INPUT_TYPE.DATE;
                        break;    
                    default:
                        break;
                }
    
                config.defaultValue = customField.defaultValue;
            }
        }
    }

    return {...systemHeader, ...config};
}

function isValidDate(date) {
    return !isNaN(Date.parse(date));
}

function getMomentDate(date) {
    return !isNaN(Date.parse(date)) ? moment(Date.parse(date)) : null;
}

export function isEmpty(value) {
    if (Array.isArray(value)) {
        return isEmpty(value[0]);
    }

    return value === null || value === undefined || String(value).trim().length === 0;
}

export function isValid(key, record, column, props) {
    const country = TenantService.get(TENANT.COUNTRY_CODE);

    if (column.required && isEmpty(record[key])) {
        return false;
    }

    let isValid = true;
    //Skip PW custom field validation
    if (column.customFieldConfig) {
        return isValid;
    }

    switch (key) {
        case FIELD.DATE_OF_JOINING:
            if (isValidDate(record[key]) && isValidDate(record[FIELD.DATE_OF_BIRTH])) {
                isValid = getMomentDate(record[key]).isAfter(getMomentDate(record[FIELD.DATE_OF_BIRTH]));
            }
            break;

        case FIELD.START_DATE:
            if (isUSCompliance() && isValidDate(record[key]) && isValidDate(record[FIELD.DATE_OF_BIRTH])) {
                isValid = getMomentDate(record[key]).isAfter(getMomentDate(record[FIELD.DATE_OF_BIRTH]));
            } else if(isUSCompliance() && !isValidDate(record[key])) {
                isValid = false;
            }
            break;
        case FIELD.DATE_OF_BIRTH:
            if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) && moment().diff(getMomentDate(record[key]), "years") < 18) {
                isValid = false;
            } else if (isUSCompliance() && isValidDate(record[FIELD.START_DATE]) && isValidDate(record[key])) {
                isValid = getMomentDate(record[FIELD.START_DATE]).isAfter(getMomentDate(record[key]));
            }
            break;
        case FIELD.CONFIRMATION_DATE:
            if (isValidDate(record[key]) && isValidDate(record[FIELD.DATE_OF_JOINING])) {
                isValid = getMomentDate(record[key]).isSameOrAfter(getMomentDate(record[FIELD.DATE_OF_JOINING]));
            }
            break;

        case FIELD.ACCOUNT_NUMBER:
            if ((record[FIELD.PAYMENT_METHOD][0] === "direct deposit" || record[FIELD.PAYMENT_METHOD][0] === "cheque" || record[FIELD.PAYMENT_METHOD][0] === "check")) {
                switch (country) {
                    case COUNTRY.US:
                        isValid = String(record[key]).length >= 4 && String(record[key]).length <= 17;
                        break;
                    case COUNTRY.IN:
                        isValid = String(record[key]).length >= 6 && String(record[key]).length <= 40;
                        break;
                    default:
                        isValid = String(record[key]).length > 0 && String(record[key]).length <= 30;
                        break;
                }
            } else {
                isValid = isEmpty(record[key]);
            }
            break;

        case FIELD.ACCOUNT_TYPE:
            isValid = record[FIELD.PAYMENT_METHOD][0] === "direct deposit" ? !isEmpty(record[key]) : isEmpty(record[key]);
            break;

        case FIELD.SWIFT_ROUTING:
            switch (country) {
                case COUNTRY.US:
                    if (record[FIELD.PAYMENT_METHOD][0] === "direct deposit") {
                        isValid = new RegExp(column.pattern).test(String(record[key]));
                    } else {
                        isValid = isEmpty(record[key]);
                    }
                    break;
                case COUNTRY.IN:
                    if (record[FIELD.PAYMENT_METHOD][0] === "direct deposit") {
                        isValid = isEmpty(record[key]) || !isEmpty(record[key]);
                    } else {
                        isValid = isEmpty(record[key]);
                    }
                    break;
            }
            break;

        case FIELD.IFSC:
            if (record[FIELD.PAYMENT_METHOD][0] === "direct deposit") {
                if (column.pattern) {
                    isValid = new RegExp(column.pattern).test(record[key]);
                } else {
                    isValid = !isEmpty(record[key]);
                }
            } else {
                isValid = isEmpty(record[key]);
            }
            break;

        case FIELD.UPI:
            if (record[FIELD.PAYMENT_METHOD][0] === "upi") {
                isValid = new RegExp(column.pattern).test(record[key]);
            } else {
                isValid = isEmpty(record[key]);
            }
            break;

        case FIELD.ZIPCODE:
          switch(country) {
            case COUNTRY.SG:
              if(!Utility.isEmpty(record[key])) {
                isValid = new RegExp(ZIPCODE_REGEX_IMPORT[country]).test(record[key]);
              } else {
                isValid = isEmpty(record[key]);
              }
          }
          break;
        case FIELD.PAN:
        case FIELD.UAN:
        case FIELD.PF_ACCOUNT_NUMBER:
        case FIELD.SSN:
            isValid = new RegExp(column.pattern).test(record[key]);
            break;

        case FIELD.CTC:
            if (!isEmpty(record[key])) {
                isValid = record[key] > 0;
            }
            break;

        case FIELD.PHONE:
            if (!isEmpty(record[key])) {
                isValid = !Utility.isPhoneValid(String(record[key]), country);
            }
            break;

        case FIELD.PUNCH_TIME:
            if (!isEmpty(record[key])) {
                const time = parseTimeIn24Hrs(record[key])
                isValid = !isEmpty(time.hours) && !isEmpty(time.minutes);
            }
            break;
        case FIELD.EMPLOYEE_QUALIFICATION:
            if (isValidDate(record[FIELD.START_OF_PERMANENT_RESIDENT])) {
                const currentDate = new Date();
                const twoYrsBackDate = new Date(currentDate.getFullYear() - 2, currentDate.getMonth(), 0);
                twoYrsBackDate.setHours(0, 0, 0, 0);
                if (getMomentDate(record[FIELD.START_OF_PERMANENT_RESIDENT]).toDate().getTime() <= twoYrsBackDate.getTime()) {
                    isValid = record[FIELD.EMPLOYEE_QUALIFICATION] === "Contribution Not At Full Rate";
                } else {
                    isValid = record[FIELD.EMPLOYEE_QUALIFICATION] === "Partial (also known as Graduated) Employer and Employee rates"
                    || record[FIELD.EMPLOYEE_QUALIFICATION] === "Full Employer and Partial (also known as Graduated) Employee rates";
                }
            }
            break;
        case FIELD.UID:
            if (country === COUNTRY.IN) {
                isValid = new RegExp(column.pattern).test(record[key]);
            }
            break;
        case FIELD.DEFAULT_HRS:
            if (country === COUNTRY.IN) {
                if (record[FIELD.PERIOD][0] === "per hour") {
                    isValid = record[key] > 0 && record[key] <= 24;
                } else {
                    isValid = (record[key] > 0 && record[key] <= 24) || !record[key];
                }
            }
            break;
        case FIELD.NRIC_FIN:
          switch(country) {
            case COUNTRY.SG:
              if(record[FIELD.IMMIGRATION_STATUS] === "Singapore Citizen" 
                || record[FIELD.IMMIGRATION_STATUS] === "Permanent Resident") {
                isValid = new RegExp(NRIC_REGEX).test(record[key]);
              } else if(record[FIELD.IMMIGRATION_STATUS] === "Foreigner (Employment Pass)" 
                || record[FIELD.IMMIGRATION_STATUS] === "Foreigner (S Pass)") {
                isValid = new RegExp(FIN_REGEX).test(record[key]);
              }
              break;
          }
          break;
        default:
            break;
    }

    if (props.tableName === TABLES.PEOPLE_COMPONENT && column.fieldId && Array.isArray(props.components)) {
        isValid = isValidateComponentValue(record, column, props.components);
    }

    if (column.customField) {
        isValid = isValidateCustomFieldValue(column, record[key]);
    }

    return isValid;
}

function isValidateComponentValue(record, column, components) {
    let isValid = true;

    const component = components.find((c) => c.id === column.fieldId);
    if (component) {
        switch (component.subType) {
            case "basic_salary":
                isValid = record[column.key] >= 0 && record[column.key] <= CONSTANTS.BASIC_THRESHOLD;
                break;
            case "hra":
                isValid = record[column.key] >= 0 && record[column.key] <= CONSTANTS.HRA_THRESHOLD;
                break;
            default:
                isValid = !isEmpty(record[column.key]) ? record[column.key] >= 0 : true;
                break;
        }
    }

    return isValid;
}

export function checkInvalidRecord(invalidFields, record, mapping) {
    mapping.forEach((column) => {
        if (!isValid(column.key, record, column, mapping)) {
            if (invalidFields.indexOf(column.key) === -1) {
                invalidFields.push(column.key);
            }
        }
    });

    return invalidFields;
}

export function getImportRecords(importRecords, mappedHeaders) {
    return importRecords.map((record) => {
        const newRecord = {};
        Object.keys(record).forEach((key) => {
            const systemHeader = mappedHeaders.find((sh) => sh.dkColKey === key);
            if (systemHeader) {
                switch (systemHeader.type) {
                    case INPUT_TYPE.SELECT:
                        if (Array.isArray(record[key])) {
                            const option = systemHeader.options.find((o) => o.id === record[key][0]);
                            if (option) {
                                newRecord[systemHeader.dkColName] = option.name;
                            } else {
                                newRecord[systemHeader.dkColName] = "";
                            }
                        } else {
                            newRecord[systemHeader.dkColName] = record[key];
                        }
                        break;
                    case INPUT_TYPE.DATE:
                        if (!isValidDate(record[key])) {
                            newRecord[systemHeader.dkColName] = record[key];
                        }
                        if (isValidDate(record[key])) {
                            switch (TenantService.get(TENANT.COUNTRY_CODE)) {
                              case COUNTRY.IN:
                                newRecord[systemHeader.dkColName] =
                                  getMomentDate(record[key]).format(
                                    "DD/MM/YYYY"
                                  );
                                break;
                              case COUNTRY.US:
                                newRecord[systemHeader.dkColName] =
                                  getMomentDate(record[key]).format(
                                    "MM/DD/YYYY"
                                  );
                                break;
                              case COUNTRY.SG:
                                newRecord[systemHeader.dkColName] =
                                getMomentDate(record[key]).format(
                                  "DD/MM/YYYY"
                                );
                                break;
                              case COUNTRY.MY:
                                newRecord[systemHeader.dkColName] =
                                getMomentDate(record[key]).format(
                                  "DD/MM/YYYY"
                                );
                                break;
                              default:
                                newRecord[systemHeader.dkColName] =
                                getMomentDate(record[key]).format(
                                  "DD/MM/YYYY"
                                );
                            }
                        }

                        break;
                    default:
                        newRecord[systemHeader.dkColName] = record[key];
                        break;
                }

                switch (key) {
                    case FIELD.PHONE:
                        if (!isEmpty(record[key])) {
                            newRecord[systemHeader.dkColName] = !String(record[key]).includes(getCountryPhoneCode()) ? String(getCountryPhoneCode()).concat(record[key]) : record[key];
                        }
                        break;
                }
            }
        });

        return newRecord;
    });
}

export function parseTimeIn24Hrs(time) {
    const parsedTime = {
        hours: null,
        minutes: null
    };

    if (time) {
        const regex24 = new RegExp("^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$");
        const regex12 = new RegExp("^(0?[1-9]|1[012])(:[0-5]\\d)\\s?[AaPp][Mm]$", "g");

        if (regex24.test(time)) {
            const t = time.split(":");
            parsedTime.hours = parseInt(t[0]);
            parsedTime.minutes = parseInt(t[1]);
        } else if (regex12.test(time)) {
            const regexPM = new RegExp("PM", "ig");
            if (regexPM.test(time)) {
                time = time.substring(0, time.toLowerCase().indexOf("pm")).trim();
                const t = time.split(":");
                parsedTime.hours = 12 + parseInt(t[0]) < 24 ? 12 + parseInt(t[0]) : 0;
                parsedTime.minutes = parseInt(t[1]);
            } else {
                time = time.substring(0, time.toLowerCase().indexOf("am")).trim();
                const t = time.split(":");
                parsedTime.hours = parseInt(t[0]);
                parsedTime.minutes = parseInt(t[1]);
            }
        }
    }

    return parsedTime;
}

export function getFormattedTime(date) {

    if (date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();

        return getFormattedTimeString(hours, minutes);
    }

    return "";
}

export function getFormattedTimeString(hours, minutes) {
    if (isEmpty(hours) || isEmpty(minutes)) {
        return "";
    }

    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${minutes}`;
}

function isValidateCustomFieldValue(column, value) {
    let isValid = column.required ? !isEmpty(value) : true;

    if (!isEmpty(value)) {
        switch (column.type) {
            case INPUT_TYPE.TEXT:
                isValid = value.length <= column.maxLength;
                break;
            case INPUT_TYPE.NUMBER:
                const [i, f = ""] = (value).toString().split(".");
                isValid = f.length <= column.decimalPrecision;
                break;
            default:
                break;
        }
    }

    return isValid;
}

export function autopopulateCustomFieldDefaultValue(record, columns) {
    columns.forEach((column) => {
        if (column.customField && column?.defaultValue && column?.defaultValue[0] && isEmpty(record[column.key])) {
            switch (column.type) {
                case INPUT_TYPE.TEXT:
                case INPUT_TYPE.NUMBER:
                    record[column.key] = column.defaultValue[0];
                    break;
                case INPUT_TYPE.MULTI_SELECT:
                case INPUT_TYPE.SELECT:
                    record[column.key] = [String(column.defaultValue[0]).toLowerCase()];
                    break;
                default:
                    break;
            }
        }
    });
}
